import "./src/index.css";
import "./src/styles/swiper.css";
import "./src/translations";

import type { GatsbyBrowser } from "gatsby";

import PageShell from "./src/gatsby/PageShell";

// The site is intentionally English-only: i18n is pinned to "en" and the
// LanguageSelector is unmounted (see add56bf "force English only"). Do NOT
// restore localStorage["lang"] here — builds prior to that switch auto-detected
// the browser language and persisted it without any user action, so returning
// visitors still carry stale values (e.g. {"code":"zht"}) that would flip the
// page out of English after hydration and mismatch the SSR'd lang="en" HTML.
export const wrapPageElement: GatsbyBrowser["wrapPageElement"] = ({
  element,
  props,
}) => <PageShell locationSearch={props.location.search}>{element}</PageShell>;
